import script from "./ReferenceTabNavigation.vue?vue&type=script&setup=true&lang=js"
export * from "./ReferenceTabNavigation.vue?vue&type=script&setup=true&lang=js"

import "./ReferenceTabNavigation.vue?vue&type=style&index=0&id=bac6d3ae&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bac6d3ae"]])

export default __exports__